import { render, staticRenderFns } from "./My_report.vue?vue&type=template&id=64336c62"
import script from "./My_report.vue?vue&type=script&lang=js"
export * from "./My_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports